import { Box } from "@chakra-ui/react";
import ClientContainer from "views/Customers/CustomerList/ClientContainer";
import OrderContainer from "views/Orders/OrderContainer";

const Orders = ({ }) => {
  return (
    < >
      <OrderContainer />
    </>
  );
};

export default Orders;
